'use strict';

class Rates {    

    createPdf(form) {
        $('#rate_reset').on('click', this.resetResult);
        $(form).on('change', (e) => {
            this.resetResult();
        });        
        $(form).on('beforeSubmit', (e) => {
            e.preventDefault();

            $('#request_rates_generate').addClass('disabled').attr('disabled', 'disabled');
            $('#request_rates_generate .spinner-border').removeClass("hidden")
            $('#rate_get_pdf').attr('href', "#").addClass('disabled').attr('disabled', 'disabled');

            let url = '/rates/validate-end'
            let data = $(form).serializeArray();
            let callback = (result) => {
                $('#request_rates_generate').removeClass('disabled').removeAttr('disabled', 'disabled');
                $('#request_rates_generate .spinner-border').addClass("d-none");
                this.pushResult(result);
            };

            data.push({
                name: 'place_count',
                value: this.place_count
            })

            let request = new Ajax({
                url: url,
                data: data,
                callback: callback,
                error: function (err) {
                    Swal.fire({
                        icon:"error",
                        text:"Произошла ошибка"
                    });
                    $('#request_rates_generate').removeClass('disabled').removeAttr('disabled', 'disabled');
                    $('#request_rates_generate .spinner-border').addClass("hidden");                    

                }
            })

            request.ajaxRequest();

            return false;
        });
    }
    resetResult(){
        $('#rate_get_pdf').attr('href', "#").removeClass('disabled').removeAttr('disabled', 'disabled');
        $('#rate_get_pdf').closest('.switch-container').addClass('d-none');
        $('#request_rates_generate').closest('.switch-container').removeClass('d-none');

    }
    pushResult(result) {
        if (result.status) {
            $('#rate_get_pdf').attr('href', result.getLink).removeClass('disabled').removeAttr('disabled', 'disabled');
            $('#request_rates_generate .spinner-border').addClass("hidden")
            $('#rate_get_pdf').closest('.switch-container').removeClass('d-none');
            $('#request_rates_generate').closest('.switch-container').addClass('d-none');
        }
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = Rates;
}